

export const ENSEIGNANT_MES_COURS_INITIATE_FETCH_LISTE_COURS = 'ENSEIGNANT_MES_COURS_INITIATE_FETCH_LISTE_COURS';
export const ENSEIGNANT_MES_COURS_FETCH_LISTE_COURS_START = 'ENSEIGNANT_MES_COURS_FETCH_LISTE_COURS_START';
export const ENSEIGNANT_MES_COURS_FETCH_LISTE_COURS_SUCCESS = 'ENSEIGNANT_MES_COURS_FETCH_LISTE_COURS_SUCCESS';
export const ENSEIGNANT_MES_COURS_FETCH_LISTE_COURS_FAIL = 'ENSEIGNANT_MES_COURS_FETCH_LISTE_COURS_FAIL';
export const ENSEIGNANT_MES_COURS_FETCH_LISTE_COURS_RESET = 'ENSEIGNANT_MES_COURS_FETCH_LISTE_COURS_RESET';